<template>
  <router-view class="full-height"></router-view>
</template>

<script>
export default {
  name: "ABMView",
  components: {},
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>
